import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import UserDatabases from '@Services/UserDatabases';
import StructureService from '@Services/Structure/StructureService';
import store from '@Store';
import { showCopiedToastMessage } from '@Containers/ToastMessages/CopiedToastMessage/CopiedToastMessageAction';
import Catalyst from '@Services/Catalyst';

/**
 * label and name of customer svg icon files in icons folder
 */
const CUSTOMER_MAPPING_ELI_LILLY = { label: 'Eli Lilly', icon: 'eli-lilly' };
const CUSTOMER_MAPPING_REAXYS = { label: 'Elsevier Reaxys', icon: 'reaxys-icon' };

/**
 * many to one mapping of customer tenant ids
 */
const CUSTOMER_NAMES_AND_ICONS_MAPPING = {
  pai_dev: CUSTOMER_MAPPING_REAXYS,
  pai_loadtest: CUSTOMER_MAPPING_REAXYS,
  iktos_dev: CUSTOMER_MAPPING_REAXYS,
  iktos_loadtest: CUSTOMER_MAPPING_REAXYS,

  elililly: CUSTOMER_MAPPING_ELI_LILLY,
  'elililly-iktos': CUSTOMER_MAPPING_ELI_LILLY,
};

/**
 * generate customer icon arial label value
 * @param customerLabel
 * @returns {string}
 */
export function getCustomerIconAriaLabel(customerLabel) {
  return `Building Block from: ${customerLabel}  click to copy SMILES`;
}

/**
 * get mapped icon name and label
 * @param customerName
 * @returns label & svg icon name object
 */
export function getCustomerSpecificMapping(customerName) {
  return CUSTOMER_NAMES_AND_ICONS_MAPPING[customerName];
}

/**
 * checks if needed to render customer specific icon in structure toolbar
 * @param customerInfo
 * @returns true if should be rendered
 */
export function isCustomerIconVisible(customerInfo) {
  return customerInfo && customerInfo.showIcon && customerInfo.name && !!getCustomerSpecificMapping(customerInfo.name);
}

/**
 * function to load and copy structure smiles to clipboard
 * @param structure
 * @returns {Promise<unknown>}
 */
export function copySmiles(structure) {
  return StructureService.convertToSmiles(structure)
    .then((smiles) => {
      navigator.clipboard.writeText(smiles.structure);
      store.dispatch(showCopiedToastMessage('The SMILES string of the structure has been copied to the clipboard.'));
    })
    .catch(Logger.error);
}

export function trackCustomerIconClick(customerName) {
  if (!customerName) return;
  Catalyst.trackEvent('buttonClick', {
    buttonType: `menu:${customerName.toLowerCase()}`, // v124
  });
}

export function canUseStructureAsFilter({ structure, metadata }) {
  const { databaseId, context, fromDocuments, fromRT, fromSynthesisPlanner, isViewPreview } = metadata;
  const hasStructure = !!structure;
  const isTargets = context === 'tgitems';
  const isStructureFilterHidden = UserDatabases.isRCSDatabase(databaseId) && Auth.isFeatureEnabled(FEATURES.hideRCSStructureFilter);

  return hasStructure && !isViewPreview && !fromDocuments && !isTargets && !fromSynthesisPlanner && !fromRT && !isStructureFilterHidden;
}
